import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrl: './chip-list.component.scss'
})
export class ChipListComponent {
  @Input() list :string[] = [];

}
